import { Sidebar } from "@rio-cloud/rio-uikit";
import { type ComponentProps } from "react";
import { ExtractSummary } from "./ExtractSummary";
import { ExtractData } from "./types/types";
import { SummaryData } from "./types/summary";
import { ConnectionEngagementCard } from "./ConnectionEngagementCard";
import { ActiveServicesCard } from "./ActiveServicesCard";
import { ContractTimeCard } from "./ContractTimeCard";

export type ExtractSidebarProps = ComponentProps<typeof Sidebar> & {
  data: ExtractData;
  assetName: string;
  extractDate: string;
};

export function ExtractSidebar({ data, assetName, extractDate, ...props }: ExtractSidebarProps) {

  const summaryDate: SummaryData = {
    assetName: assetName,
    date: extractDate
  }

  const activeServices = data?.details?.find((item)=>item.description === 'ENGAJAMENTO_SISTEMAS')
  const contractTime = data?.details?.find((item)=>item.description === 'TEMPO_RELACIONAMENTO')

  return (
    <Sidebar
      title={
        <div className="padding-x-10 text-color-dark">
          Extrato para {assetName}
        </div>
      }
      fly
      makeBackdropVisible
      hasBackdrop
      resizable
      minWidth={360}
      maxWidth={1080}
      width={720}
      position={Sidebar.RIGHT}
      {...props}
    >
      <div>
        <div className="cq-container">
          <div className="padding-x-20">
            <ExtractSummary summary={summaryDate} />
          </div>
          <div className="padding-20 display-grid grid-cols-1 cq-700:grid-cols-2 gap-20">
            <div className="cq-700:col-span-full">
              <ConnectionEngagementCard score={data.score} level={data.level} maxScore={data.maxScore} nextLevelScore={data.nextLevelScore} />
            </div>
            <div>
              <ActiveServicesCard score={activeServices?.score} maxScore={activeServices?.maxScore} status={activeServices?.status} />
            </div>
            <div>
              <ContractTimeCard score={contractTime?.score} maxScore={contractTime?.maxScore} status={contractTime?.status} />
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
